export const PROJECTS = [
    {
        slug: "monsoon-villa",
        title: "Monsoon Villa",
        category: "Private Villa",
        year: "2025",
        location: "Kundara, Kollam",
        area: "5100 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/rogj0e1w_WhatsApp%20Image%202026-08-01%20at%2015.32.44.jpeg",
        span: "md:col-span-7",
        h: "h-[460px] md:h-[560px]",
        story: [
            "Set on a lush 5,100 sq.ft plot in Kundara, Kollam, Monsoon Villa is a contemporary family home tuned for the Kerala monsoon. Layered clay-tiled gables step across the site, throwing rain clear of walls and glass so deep verandas stay dry — and usable — even through the heaviest downpour.",
            "Inside, double-height volumes pull breeze through the plan, cutting air-conditioning to a backup role. Reclaimed timber beams and cane ceiling fans crown the bedrooms, while polished green stone floors mirror the palm canopy just beyond the glass. Heritage bones, contemporary soul.",
            "Every material was chosen to age with the climate — teak, terracotta, lime plaster, and cane — so that ten monsoons from now, the villa will look better, not tired.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/rogj0e1w_WhatsApp%20Image%202026-08-01%20at%2015.32.44.jpeg",
                caption: "Stepped clay-tiled gables — the street elevation",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/tjwyhjov_IMG_1158.JPG.webp",
                caption: "Master bedroom with reclaimed teak headboard and rattan medallion",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/yzhw0ljx_IMG_1159.JPG.webp",
                caption: "Guest suite opening to the palm canopy",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/un8h4wnu_37867.jpg",
                caption: "Ground floor plan — entry, kitchens, master suite and courtyards",
                span: "md:col-span-12",
                h: "h-[55vh] md:h-[75vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/pfw93w9l_37865.jpg",
                caption: "First floor plan — bedrooms 3–5, upper living, terrace and pool",
                span: "md:col-span-12",
                h: "h-[55vh] md:h-[75vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "pyare-jewellery",
        title: "Pyare Jewellery",
        category: "Retail · Jewellery Showroom (Under Construction)",
        year: "2026",
        location: "Ezhukone, Kollam",
        area: "1,100 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/25qmlibp_WhatsApp%20Image%202026-08-05%20at%2010.35.45.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Pyare Jewellery is a 1,100 sq.ft showroom taking shape in Ezhukone, Kollam — a boutique retail space designed to let the pieces do the talking. Soft sage-green walls, brass-toed cream counters and floor-to-ceiling backlit niches turn each necklace bay into its own miniature gallery.",
            "A ribbon of cove-lit ceiling curves through the room, drawing shoppers past a cane-and-marble feature wall of chandelier necklace panels into a wider hall lined with linear display cases and low benches for consultations. Every fixture is tuned so the diamond and gold catch the warmest colour temperature the eye can read.",
            "Construction is underway on-site — plywood carcasses, terrazzo floor and a cove-hidden LED strip already give the room its first light. Handover is expected in early 2026.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/7y06aacq_WhatsApp%20Image%202026-08-05%20at%2010.37.21.jpeg",
                caption: "Design render — backlit necklace bays and cream display counters",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/67nukzjh_WhatsApp%20Image%202026-08-05%20at%2010.35.45.jpeg",
                caption: "Ribbon ceiling and sage-green feature wall — the MAKEUP category niche",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/t7cpys3s_WhatsApp%20Image%202026-08-05%20at%2010.35.02.jpeg",
                caption: "Merchandising strategy — ACCESSORIES, SKINCARE and MAKEUP display zones",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/mbcm0zb2_WhatsApp%20Image%202026-08-05%20at%2010.35.01%20%281%29.jpeg",
                caption: "On site — carpentry carcasses being installed along the display wall",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/z903u6is_WhatsApp%20Image%202026-08-05%20at%2010.35.01.jpeg",
                caption: "Ceiling coves and linear pendants going up — first light on site",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "casa-terra",
        title: "Casa Terra",
        category: "Private Residence · Under Construction",
        year: "2026",
        location: "Kavanadu, Kollam",
        area: "2,800 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/9aqm8kha_Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20FOYER%20SPACE.jpg.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Casa Terra is a 2,800 sq.ft residence taking shape in Kavanadu, Kollam — a study in contrasts where soft terracotta lime-plaster volumes rise from a grey cement-finish plinth, meeting a screened terrace garden between the two floors.",
            "Sculpted parapet curves crown the terracotta blocks, echoing the arched sky and softening the geometry against the Kerala coconut canopy. A punched pattern in one wall lets evening light bleed onto the front court, while a fine cast-in-place jaali on the other end filters the western sun into the upper bedrooms.",
            "The plan zones itself gently — a foyer, formal living, dining, working kitchen and pooja on the ground floor around a foldable-table dining space, with a master and guest bedroom flanking the sitout. Upstairs, an open double-height overlooks the dining, two more bedrooms sit alongside walk-in wardrobes, and a wrap-around open terrace catches the monsoon breeze.",
            "Currently under construction — a home built to age into its landscape as slowly as the terracotta warms with the sun.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/pnwzzj75_ChatGPT%20Image%20Aug%201%2C%202026%2C%2007_41_54%20PM.png",
                caption: "Design perspective — terracotta volumes over a cement plinth",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/i7y6f6o5_Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20FOYER%20SPACE.jpg.jpeg",
                caption: "Design sheet — ground floor and first floor plans, at a glance",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[65vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "rithanya-natya-kshetra",
        title: "Rithanya Natya Kshetra",
        category: "Classical Dance Studio",
        year: "2024",
        location: "Kollam",
        area: "600 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/wxx68v9k_WhatsApp%20Image%202026-08-01%20at%2015.35.42.webp",
        span: "md:col-span-5",
        h: "h-[460px] md:h-[560px]",
        story: [
            "Rithanya Natya Kshetra is a 600 sq.ft Classical Dance Studio in Kollam, designed as an instrument for practice. A sprung timber floor, a backlit arched wall carrying the Rithanya logotype in devanagari script, and acoustically soft walls let dancers hear their own footwork.",
            "Hand-painted classical dancer murals anchor the side walls — the room becomes a rehearsal space and a shrine to the form at the same time. Warm linear pendants and grazing wall-washers keep the studio theatrical without a single spotlight's glare.",
            "Built joinery in teak conceals storage benches for parents and students, and a low pink accent runs along the base to mark the ritual threshold of the practice floor.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/wxx68v9k_WhatsApp%20Image%202026-08-01%20at%2015.35.42.webp",
                caption: "The dancer-mural wall meets the arched mirror bay",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/lqzv57jd_WhatsApp%20Image%202026-08-01%20at%2015.35.41.webp",
                caption: "The backlit arched logotype wall",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/1s4pe9ql_WhatsApp%20Image%202026-08-01%20at%2015.35.41%20%282%29.webp",
                caption: "Bharatanatyam mural triptych under grazing spotlights",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/bkkp03sk_WhatsApp%20Image%202026-08-01%20at%2015.35.40.webp",
                caption: "Teak-clad seating with pink ritual accent",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/4740lvu9_WhatsApp%20Image%202026-08-01%20at%2015.35.41%20%281%29.webp",
                caption: "Studio at rest — the practice floor",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/hbrgrfl4_WhatsApp%20Image%202026-08-01%20at%2015.35.40%20%281%29.webp",
                caption: "Dancer figure — entry axis close-up",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "vishnudeth-residence",
        title: "Mr. Vishnudeth Residence",
        category: "Private Villa · Interior",
        year: "2026",
        location: "Kottarakara, Kollam",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/wtlo1mzh_Gemini_Generated_Image_c64n26c64n26c64n.webp",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "The Vishnudeth Residence in Kottarakara, Kollam is a contemporary family home rooted in Kerala craft. Hand-carved teak columns from a demolished tharavadu frame a central rain-chain courtyard — a stone Buddha sits at its base with tropical foliage, and a skylight above lets the monsoon pour visibly into a shallow pool.",
            "The kitchen is quietly modern: warm oak cabinetry with cane-webbing shutters, a vertical burnt-clay tile backsplash, and a full-height pantry column tying the working wall together. The dining edge slides into an open-plan living behind a bamboo-slat ceiling that softens light through the day.",
            "Bedrooms are hushed, terracotta-floored rooms with lattice-panel headboards, louvered teak wardrobes, and a ceiling grid that reads like a woven mat. Every room borrows daylight from the courtyard, and every material — teak, cane, terracotta, lime plaster — is honest enough to age gracefully in the Kollam climate.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/wtlo1mzh_Gemini_Generated_Image_c64n26c64n26c64n.webp",
                caption: "Living and dining — carved teak columns and a rain-chain Buddha courtyard",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/ccl7ck8w_Gemini_Generated_Image_mmrtzrmmrtzrmmrt.webp",
                caption: "Kitchen — cane-webbed uppers over a burnt-clay backsplash",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/nrcg1ox1_BD%20F%201.2.webp",
                caption: "Master bedroom — lattice headboard beneath the woven ceiling",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/lkfaeqfl_BD%20F%201.1.webp",
                caption: "Louvered teak wardrobes and a quiet vanity nook",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "golden-age-community",
        title: "Golden Age Community",
        category: "Design Study · Senior Living",
        year: "2024",
        location: "Kerala",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/fyf5zais_WhatsApp%20Image%202026-08-05%20at%2010.51.20.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[560px]",
        story: [
            "Golden Age Community is a design study for a low-rise senior-living neighbourhood tuned to the Kerala climate. Four residential blocks are mirrored, inverted and pulled apart to create shaded courtyards, cross-ventilation channels, and a large green common at the heart of the plan.",
            "The scheme is zoned deliberately — public commercial and park edges wrap around a semi-public band of clinics, pharmacies, banks and cafés, protecting a private residential core with its own service entry. Every home is within a short, shaded walk of care, coffee and company.",
            "Modules are designed around the residents themselves: singles, couples and families of the golden generation. Blocks step down in height from the entry gate so the ensemble reads as a village, not an institution — with solar-panel provisions and planted green roofs woven into the massing from day one. Circulation inside the community is buggy-only, keeping the ground level entirely to pedestrians.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/e6rnse89_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%282%29.jpeg",
                caption: "Residential blocks A & B — children's play, parks and evening seating",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/ujy899iv_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%281%29.jpeg",
                caption: "Movement inside the community is buggy-only, ground kept to pedestrians",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/0mtheji9_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%283%29.jpeg",
                caption: "Residential Block A — timber-screened facade with backlit signage",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/5hlijl23_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%284%29.jpeg",
                caption: "Cantilevered lounge with views towards the commercial spine",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/qcursx8n_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%285%29.jpeg",
                caption: "Green rooftop garden — yoga at dawn, grandchildren at dusk",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/lbzezfg0_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%286%29.jpeg",
                caption: "Road-facing edge — a brutalist, modernist civic frontage",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/o2xz8eb4_WhatsApp%20Image%202026-08-01%20at%2015.56.17%20%287%29.jpeg",
                caption: "Golden Mart — supermarket open to residents and the wider public",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/cggyss7h_WhatsApp%20Image%202026-08-01%20at%2015.54.09.jpeg",
                caption: "Design perspective — solar-ready roofs and stepped green terraces",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/gh2nt25t_WhatsApp%20Image%202026-08-01%20at%2015.54.33.jpeg",
                caption: "Zoning strategy and concept-mass development",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/zj878e17_WhatsApp%20Image%202026-08-01%20at%2015.54.53.jpeg",
                caption: "Four mirrored modules forming a V-shaped common courtyard",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/qz5x1oat_WhatsApp%20Image%202026-08-01%20at%2015.55.12.jpeg",
                caption: "Visual hierarchy — block heights read from the entry gate",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/fujxcii5_WhatsApp%20Image%202026-08-01%20at%2015.55.33.jpeg",
                caption: "Modules tuned for singles, couples and families",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/ua4oh7bg_WhatsApp%20Image%202026-08-01%20at%2015.55.45.jpeg",
                caption: "Residential block breakdown — R1–R4 with amenities and lobby cores",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/4vahhrxt_WhatsApp%20Image%202026-08-01%20at%2015.55.53.jpeg",
                caption: "Unit floor plans — couples' and families' apartments",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "sabu-cs-company",
        title: "Sabu CS & Company",
        category: "Commercial · C.A. Office",
        year: "2026",
        location: "Chinnakada, Kollam",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/7bqdjewa_WhatsApp%20Image%202026-08-01%20at%2017.32.56.jpeg",
        imgPosition: "center 50%",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Sabu CS & Company is a chartered accountant's office in the heart of Chinnakada, Kollam — a working practice designed to look and feel as considered as its clients' books. A warm, tan-toned reception frames a backlit black-letter signage wall, flanked by a glass-block partition that lets daylight bleed into the workspace beyond.",
            "The open workfloor is anchored by linear pendants and a soft micro-cement palette. Frosted-glass desk dividers give staff acoustic and visual privacy without breaking sightlines, and every workstation gets its own draw-blind window, task chair and cable-managed drawer bank.",
            "A private principal's cabin in a deeper caramel tone offers a quieter room for review meetings — floating cabinets, a book ledge lined with tax and companies-act titles, and a black leather high-back chair set the tone. The whole office reads as a professional space that lists its details, not shouts them.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/by41o3ul_WhatsApp%20Image%202026-08-01%20at%2017.32.55.jpeg",
                caption: "Principal's cabin — leather high-back with the Income Tax Act on the ledge",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/1vv5fv9r_WhatsApp%20Image%202026-08-01%20at%2017.32.56%20%283%29.jpeg",
                caption: "Reception — the SABU CS & COMPANY signage wall",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/n0544q93_WhatsApp%20Image%202026-08-01%20at%2017.32.56%20%281%29.jpeg",
                caption: "Workstation edge with sightline to the reception beyond",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/da58660p_WhatsApp%20Image%202026-08-01%20at%2017.32.56%20%282%29.jpeg",
                caption: "Glass-block partition detail and tan banquette bench",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/awvxrfru_WhatsApp%20Image%202026-08-01%20at%2017.32.55%20%281%29.jpeg",
                caption: "Team workstations with frosted-glass dividers",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/8k5yne31_WhatsApp%20Image%202026-08-01%20at%2017.32.57.jpeg",
                caption: "Blue joinery wall of storage above the workstation run",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/zc0x6dwz_WhatsApp%20Image%202026-08-01%20at%2017.32.56.jpeg",
                caption: "Waiting corner — tan leather sofa under the signage",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "ground-gallery-park",
        title: "Ground Gallery Park",
        category: "Landscape · Public Park",
        year: "2023",
        location: "Gandhi Nagar, Kochi",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/e45j0jt8_WhatsApp%20Image%202026-08-01%20at%2018.22.34.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Ground Gallery Park is a neighbourhood-scale public landscape for Gandhi Nagar, Kochi — a long, narrow site woven together by four road entries, an art-wall boundary, and a soft green spine that carries residents from the children's play area to a sunken amphitheatre at the far end.",
            "The design layers programme along the spine: a play zone with slides and see-saws for the youngest, a sound-garden and sculpted art garden for pause, a stepped amphitheatre and stage for evening events, and a small office and toilet block to keep the park cared-for through the day.",
            "Curving pebble-inlay paths bind the zones together, buffalo grass carpets the open commons, and low art walls (600mm) mediate between the park and the surrounding streets so children can play safely without ever feeling walled in.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/v55ukeut_WhatsApp%20Image%202026-08-01%20at%2018.22.34%20%281%29.jpeg",
                caption: "Aerial view — the green spine threading through Gandhi Nagar",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/f1slsbe9_WhatsApp%20Image%202026-08-01%20at%2018.22.34.jpeg",
                caption: "Children's play area — spiral slide, see-saws and shaded pergola",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/aon75fnq_WhatsApp%20Image%202026-08-01%20at%2018.20.54.jpeg",
                caption: "Master site plan — entries, play, sound garden, amphitheatre and stage",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[65vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "hashim-residence",
        title: "Mr. Hashim Residence",
        category: "Private Villa",
        year: "2024",
        location: "Pandikkad, Malappuram",
        area: "2,900 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/46gndjoq_WhatsApp%20Image%202026-08-01%20at%2017.17.07.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "The Hashim Residence is a 2,900 sq.ft contemporary family home in Pandikkad, Malappuram. Two crisp white volumes are stacked and slid over each other, with deep overhangs and warm timber-slat soffits that soften the geometry and cool the rooms below.",
            "The plan is layered — a formal living room and a family living-and-dining wing flank a central courtyard passage, keeping guest and family life comfortably separate. The kitchen opens to a service work-area and a shaded utility patio, while a sit-out at the front handles the everyday chai-and-newspaper ritual.",
            "Upstairs, an open-below double-height family lounge overlooks the ground-floor living, three ensuite bedrooms wrap around a central passage, and a generous open terrace catches Malappuram's evening breeze. The whole home is quietly modern, but built for how a Kerala family actually lives.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/46gndjoq_WhatsApp%20Image%202026-08-01%20at%2017.17.07.jpeg",
                caption: "Front elevation — stacked volumes with timber-slat soffits",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/f2u4irjc_WhatsApp%20Image%202026-08-01%20at%2017.17.06.jpeg",
                caption: "Rear elevation — screened balcony with hanging garden",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/4sb9k1b4_WhatsApp%20Image%202026-08-01%20at%2017.14.03.jpeg",
                caption: "Ground floor plan — living wings around a central passage",
                span: "md:col-span-6",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/4krsvryy_WhatsApp%20Image%202026-08-01%20at%2017.14.03%20%281%29.jpeg",
                caption: "First floor plan — bedrooms, upper living and open terrace",
                span: "md:col-span-6",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "posh-ceramics",
        title: "Posh Ceramics",
        category: "Retail · Showroom",
        year: "2024",
        location: "Perumbavoor",
        area: "12,000 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/geyfub8v_WhatsApp%20Image%202026-08-01%20at%2018.21.10.jpeg",
        imgPosition: "center 55%",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Posh Ceramics is a 12,000 sq.ft ceramic and sanitaryware showroom on the Perumbavoor highway — a landmark building that reads from a moving car. The façade is a sculpted composition of vertical fins with a sweeping arc cut through the mass, echoing the fluid glaze work the brand is known for.",
            "The design story runs from concept render, through construction, to the finished storefront. A punchy teal-and-white palette pushes the building forward against the Kerala green, while an oversized signage medallion floats above the corner as a highway marker.",
            "Inside the volume sits a column-free, top-lit display hall — engineered to let clients read tile at true scale, under conditions close to how it will finally live in their homes.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/363x0ygi_WhatsApp%20Image%202026-08-01%20at%2015.40.25%20%281%29.jpeg",
                caption: "The finished storefront on Perumbavoor highway",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/vhdv690j_WhatsApp%20Image%202026-08-01%20at%2015.40.25.jpeg",
                caption: "Design concept — sculpted fin façade with signage medallion",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/5tbt590f_WhatsApp%20Image%202026-08-01%20at%2015.40.24.jpeg",
                caption: "Under construction — mass before the paint reveal",
                span: "md:col-span-6",
                h: "h-[42vh] md:h-[55vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/2uswm4zt_WhatsApp%20Image%202026-08-01%20at%2018.21.10%20%281%29.jpeg",
                caption: "Interior fit-out — scaffolding for the top-lit display hall",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/4ot9u4y8_WhatsApp%20Image%202026-08-01%20at%2018.21.10.jpeg",
                caption: "Structural shell — steel-truss frame before cladding",
                span: "md:col-span-12",
                h: "h-[46vh] md:h-[60vh]",
                position: "center",
            },
        ],
    },
    {
        slug: "residence-sakthikulangara",
        title: "Residence Sakthikulangara",
        category: "Private Villa",
        year: "2025",
        location: "Sakthikulangara, Kollam",
        area: "1,750 sq.ft",
        img: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/ai4xyapd_WhatsApp%20Image%202026-08-05%20at%2010.39.48.jpeg",
        span: "md:col-span-12",
        h: "h-[460px] md:h-[600px]",
        story: [
            "Residence Sakthikulangara is a 1,750 sq.ft contemporary home in Sakthikulangara, Kollam — two crisp volumes in cement-plaster and vertical timber slats, stacked and cantilevered over a shaded ground level. A slim floating roof edge in warm oak-toned soffit runs across the top, tying the geometry together.",
            "The ground floor plan opens through a sit-out (510×170) into a family living (350×360), a dining room (396×362), a working-kitchen with a 270×222 work-area, and a private master bedroom (362×370) with attached toilet. A tucked-away pooja (120×150) sits beside the stair — a quiet ritual anchor for the home.",
            "Upstairs, a compact first floor holds a second bed room (362×370) with its own toilet and a wraparound sitout that becomes the family's private terrace. Planter troughs of green foliage soften the balcony edge, and a slatted screen on the west elevation controls the afternoon sun.",
        ],
        gallery: [
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/ai4xyapd_WhatsApp%20Image%202026-08-05%20at%2010.39.48.jpeg",
                caption: "Design perspective — cement-plaster volumes with vertical timber slats",
                span: "md:col-span-12",
                h: "h-[50vh] md:h-[70vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/und3pf4r_WhatsApp%20Image%202026-08-05%20at%2010.40.35.jpeg",
                caption: "Ground floor plan — living, dining, kitchen, master bed and pooja",
                span: "md:col-span-6",
                h: "h-[50vh] md:h-[65vh]",
                position: "center",
            },
            {
                src: "https://customer-assets-agu9un31.emergentagent.net/job_abi-deploy-check/artifacts/f0olenwj_WhatsApp%20Image%202026-08-05%20at%2010.40.35%20%281%29.jpeg",
                caption: "First floor plan — second bedroom and wrap-around sitout",
                span: "md:col-span-6",
                h: "h-[50vh] md:h-[65vh]",
                position: "center",
            },
        ],
    },
];
